import Navbar from "@/components/site/Navbar";
import ScrollProgress from "@/components/site/ScrollProgress";
import { useEffect } from "react";
import { scrollToSection } from "@/lib/scroll";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import WhyChoose from "@/components/site/WhyChoose";
import Portfolio from "@/components/site/Portfolio";
import Testimonials from "@/components/site/Testimonials";
import Calculator from "@/components/site/Calculator";
import Quiz from "@/components/site/Quiz";
import LiveDemo from "@/components/site/LiveDemo";
import Process from "@/components/site/Process";
import Blog from "@/components/site/Blog";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import AIWidget from "@/components/site/AIWidget";

export default function Landing() {
  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (hash) {
      const t = setTimeout(() => scrollToSection(hash), 400);
      return () => clearTimeout(t);
    }
  }, []);
  return (
    <div className="relative grain min-h-screen bg-[#0B1220] text-white overflow-x-hidden">
      <ScrollProgress />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <Services />
        <WhyChoose />
        <Portfolio />
        <Testimonials />
        <Calculator />
        <Quiz />
        <LiveDemo />
        <Process />
        <Blog />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <AIWidget />
    </div>
  );
}
